import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import DialogClose from 'views/components/buttons/DialogClose';
import useAssignedForms from './useAssignedForms';

interface Props extends DialogProps {
  assignId: string;
  onClose: () => void;
}
const refillMap = new Map([
  ['Minutes', 60000],
  ['Hours', 3600000],
  ['Days', 86400000],
  ['Weeks', 604800000]
]);
const RefillModal = ({ assignId, onClose, ...props }: Props) => {
  const { updateRefillAsync, updateRefillIsLoading, refillData } = useAssignedForms({ assignId });
  const [refillForm, setRefillForm] = useState(false);
  const [refillAfter, setRefillAfter] = useState<number | undefined>();
  const [legendRadioValue, setLegendRadioValue] = useState('');
  useEffect(() => {
    setRefillForm(refillData?.allowRefill);
    setRefillAfter(Number(refillData?.refillAfter) / Number(refillMap?.get(refillData?.timeParameter) || 1));
    setLegendRadioValue(refillData?.timeParameter);
  }, [refillData]);
  const handleRefillForm = useCallback((e: any) => setRefillForm(e.target.checked), []);
  const handleChangeLegendRadioGroup = useCallback((_, value) => {
    setLegendRadioValue(value);
  }, []);
  const handleSubmit = useCallback(async () => {
    const payload = {
      allowRefill: refillForm,
      refillAfter,
      timeParameter: legendRadioValue
    };
    if (refillAfter) {
      // switch (legendRadioValue) {
      //   case 'Minutes': {
      //     payload.refillAfter = refillAfter * 60 * 1000;
      //     break;
      //   }
      //   case 'Hours': {
      //     payload.refillAfter = refillAfter * 60 * 60 * 1000;
      //     break;
      //   }
      //   case 'Days': {
      //     payload.refillAfter = refillAfter * 24 * 60 * 60 * 1000;
      //     break;
      //   }
      //   case 'Weeks': {
      //     payload.refillAfter = refillAfter * 7 * 24 * 60 * 60 * 1000;
      //     break;
      //   }
      // }
      payload.refillAfter = refillAfter * (refillMap?.get(legendRadioValue) || 0);
    }
    await updateRefillAsync(payload);
    onClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refillAfter, refillForm, legendRadioValue]);
  return (
    <Dialog maxWidth="sm" fullWidth sx={{ '& .MuiDialog-paper': { p: 0 } }} onClose={onClose} {...props}>
      <DialogTitle>
        <Typography variant="h4">
          <FormattedMessage defaultMessage="Setup refill interval" />
        </Typography>
        <DialogClose onClose={onClose} />
      </DialogTitle>
      <DialogContent>
        <Typography variant="h5">
          <FormattedMessage defaultMessage="Refill Reminder" />
        </Typography>
        <Stack direction="row" gap={1} alignItems="center">
          <Checkbox checked={refillForm} onChange={handleRefillForm} />
          <Typography>
            <FormattedMessage defaultMessage="Add Refill Reminder" />
          </Typography>
        </Stack>

        {refillForm && (
          <Stack>
            <Typography>
              <FormattedMessage defaultMessage="Refill After:" />
            </Typography>
            <TextField
              type="number"
              sx={{ width: '20%' }}
              value={refillAfter}
              onChange={(e) => Number(e.target.value) >= 0 && setRefillAfter(Number(e.target.value))}
            />
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-legend-radio-buttons-group"
              onChange={handleChangeLegendRadioGroup}
              value={legendRadioValue}
              sx={{
                display: 'flex',
                flexDirection: 'row'
              }}
            >
              <FormControlLabel value={'Minutes'} control={<Radio />} label="Minutes" />
              <FormControlLabel value={'Hours'} control={<Radio />} label="Hours" />
              <FormControlLabel value={'Days'} control={<Radio />} label="Days" />
              <FormControlLabel value={'Weeks'} control={<Radio />} label="Weeks" />
            </RadioGroup>
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleSubmit} disabled={updateRefillIsLoading}>
          <FormattedMessage defaultMessage="Save" />
        </Button>
        <Button variant="contained" onClick={onClose}>
          <FormattedMessage defaultMessage="Cancel" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RefillModal;
